import { THREE_LETTER_EUROPE_COUNTRY_CODES } from "./THREE_LETTER_EUROPE_COUNTRY_CODES";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "./THREE_LETTER_PRIMARY_COUNTRY_CODES";
var isEurope = function(k) {
    return k in THREE_LETTER_EUROPE_COUNTRY_CODES;
};
export var THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES = Object.keys(THREE_LETTER_PRIMARY_COUNTRY_CODES).filter(isEurope);
